import { usePromoFromQuery } from '../hooks/usePromoFromQuery';

/** Runs inside Router — captures discount codes from URL on any page. */
export default function PromoFromQueryHandler() {
  usePromoFromQuery();
  return null;
}
